import { render, staticRenderFns } from "./notices-container.vue?vue&type=template&id=7b9dd370&"
import script from "./notices-container.vue?vue&type=script&lang=js&"
export * from "./notices-container.vue?vue&type=script&lang=js&"
import style0 from "./notices-container.vue?vue&type=style&index=0&id=7b9dd370&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports